import IconButton from "@material-ui/core/IconButton";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";
import Typography from "@material-ui/core/Typography";
import { Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Icon } from "@common/Icon/Icon";
import { DATE_FORMAT } from "@constants";
import { PaymentDetails } from "./Details/PaymentDetails";
import { ITransaction } from "./interface/ITransactionHistory";
import { format } from "date-fns";

interface IParams {
    expandedTransaction?: string;
    transaction: ITransaction;
    month: number;
    setExpandedTransaction(expandedTransaction?: string): void;
}

export const TransactionHistory = (props: IParams) => {
    const {
        expandedTransaction,
        month,
        transaction: { amount, dateTime, reference, transactionType, paymentCorrelationTransactionUuid },
        setExpandedTransaction,
    } = props;
    const { t } = useTranslation(["common", "payment"]);

    const isExpanded = expandedTransaction === reference;

    let detailsComponent: JSX.Element | undefined;
    if (transactionType === "PAYMENT") {
        detailsComponent = (
            <PaymentDetails paymentCorrelationTransactionUuid={paymentCorrelationTransactionUuid} month={month} />
        );
    }

    const onClick = () => {
        setExpandedTransaction(isExpanded ? undefined : reference);
    };

    return (
        <Fragment>
            <TableRow hover onClick={onClick}>
                <TableCell>
                    <Typography color="secondary" variant="body2">
                        {format(new Date(dateTime), DATE_FORMAT)}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography color="secondary" variant="body2">
                        {t(`payment:${transactionType}` as any)}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Typography color="secondary" variant="body2">
                        {t("common:price", { price: amount })}
                    </Typography>
                </TableCell>
                <TableCell padding="none" variant="body">
                    {Boolean(detailsComponent) && (
                        <IconButton aria-label={isExpanded ? "Close" : "Open"} color="secondary">
                            <Icon name={`arrow-${isExpanded ? "up" : "down"}`} />
                        </IconButton>
                    )}
                </TableCell>
            </TableRow>

            {isExpanded && detailsComponent}
        </Fragment>
    );
};
